import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpEventType, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpHeaders
} from '@angular/common/http';
import'rxjs/add/operator/retry';
import'rxjs/add/operator/do';
import { Observable } from 'rxjs/Rx';
import { HttpCacheService } from '../../services/http-cache-service/http-cache.service';
export class CacheInterceptor implements HttpInterceptor {
/**
 * @param {?} cacheService
 */
constructor(private cacheService: HttpCacheService) {}
/**
 * @param {?} req
 * @return {?}
 */
checkCachingPermissions(req: HttpRequest<any>) {
    const /** @type {?} */ configHeader = !!req.headers.get('fusion-config');
    const /** @type {?} */ templateheader = !!req.headers.get('fusion-component-template');

    return req.method === 'GET' && ( configHeader || templateheader ) ? true : false;
  }
/**
 * @param {?} req
 * @param {?} next
 * @return {?}
 */
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ( !this.checkCachingPermissions(req) ) {
      return next.handle(req);
    }

    const /** @type {?} */ urlExists = this.cacheService.checkIfUrlExists(req.urlWithParams);

    if (urlExists) {
      const /** @type {?} */ cachedExisting = this.cacheService.get(req);
      if (cachedExisting) {
        return Observable.of(cachedExisting);
      } else {
        return Observable.fromPromise(
          new Promise<HttpEvent<any>>(resolve => {
            this.cacheService.onTemplateAdd.subscribe(name => {
              if (name === req.urlWithParams) {
                const /** @type {?} */ cachedNew = this.cacheService.get(req);
                if (cachedNew) {
                  resolve(cachedNew);
                }
              }
            })
          })
        )
      }
    } else {
      return next.handle(req).do((event: HttpResponse<any>) => {
        if (event instanceof HttpResponse && !this.cacheService.cache.hasOwnProperty(req.urlWithParams)) {
          this.cacheService.put(req, event);
        }
      }).catch(
        (err: HttpErrorResponse) => {
          return Observable.throw(err);
        }
      )
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpCacheService, },
];
}

function CacheInterceptor_tsickle_Closure_declarations() {
/** @type {?} */
CacheInterceptor.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CacheInterceptor.ctorParameters;
/** @type {?} */
CacheInterceptor.prototype.cacheService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
